import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_MONITORINGISSUE_CREATE,
    ACTION_MONITORINGISSUE_LOAD,
    ACTION_MONITORINGISSUE_LOAD_BY_ID,

    ACTION_MONITORINGISSUE_SAVE,
    ACTION_MONITORINGISSUE_VALIDATE,
    ACTION_MONITORINGISSUES_LOAD_BY_MONITORING_ID,
    CreateFailure,
    CreateSuccess,
    IMonitoringIssueCreateAction,
    IMonitoringIssueCreateFailureAction,
    IMonitoringIssueCreateSuccessAction,
    IMonitoringIssueLoadAction,
    IMonitoringIssueLoadByIdAction,
    IMonitoringIssueLoadFailureAction,
    IMonitoringIssueLoadSuccessAction,

    IMonitoringIssueSaveAction,
    IMonitoringIssueSaveFailureAction,
    IMonitoringIssueSaveSuccessAction,
    IMonitoringIssueValidateAction,
    IMonitoringIssueValidateFailureAction,
    IMonitoringIssueValidateSuccessAction,
    IMonitoringIssuesLoadByMonitoringIdAction,
    LoadFailure,
    LoadSuccess,
    SaveFailure,
    SaveSuccess,
    ValidateFailure,
    ValidateSuccess,
} from "../actions/monitoringIssue";
import { monitoringIssuesApi } from "../services/monitoringIssues";

export const
    getMonitoringIssuesEpic = (action$): Observable<IMonitoringIssueLoadSuccessAction | IMonitoringIssueLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGISSUE_LOAD)
            .mergeMap((_action: IMonitoringIssueLoadAction) => {
                return monitoringIssuesApi
                    .getMonitoringIssues()
                    .map(response =>
                        LoadSuccess(response.monitoringIssues, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getMonitoringIssuesByMonitoringIdEpic = (action$): Observable<IMonitoringIssueLoadSuccessAction | IMonitoringIssueLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGISSUES_LOAD_BY_MONITORING_ID)
            .mergeMap((action: IMonitoringIssuesLoadByMonitoringIdAction) => {
                return monitoringIssuesApi
                    .getMonitoringIssuesByMonitoringId(action.monitoringId)
                    .map(response =>
                        LoadSuccess(response.monitoringIssues, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getMonitoringIssuesByIdEpic = (action$): Observable<IMonitoringIssueLoadSuccessAction | IMonitoringIssueLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGISSUE_LOAD_BY_ID)
            .mergeMap((action: IMonitoringIssueLoadByIdAction) => {
                return monitoringIssuesApi
                    .getMonitoringIssueById(action.id)
                    .map(response =>
                        LoadSuccess(response.monitoringIssue, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setMonitoringIssueEpic = (action$): Observable<IMonitoringIssueSaveSuccessAction | IMonitoringIssueSaveFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGISSUE_SAVE)
            .mergeMap((action: IMonitoringIssueSaveAction) => {
                return monitoringIssuesApi
                    .setMonitoringIssue(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.monitoringIssue, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createMonitoringIssueEpic = (action$): Observable<IMonitoringIssueCreateSuccessAction | IMonitoringIssueCreateFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGISSUE_CREATE)
            .mergeMap((action: IMonitoringIssueCreateAction) => {
                return monitoringIssuesApi
                    .createMonitoringIssue(action.monitoringId)
                    .map(response =>
                        CreateSuccess(response.monitoringIssue, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateMonitoringIssueEpic = (action$): Observable<IMonitoringIssueValidateSuccessAction | IMonitoringIssueValidateFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGISSUE_VALIDATE)
            .mergeMap((action: IMonitoringIssueValidateAction) => {
                return monitoringIssuesApi
                    .validateMonitoringIssue(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.monitoringIssue, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }